import React, { useState } from "react";
import "./assignDriver.scss";
import { Form, Formik, FormikProps } from "formik";
import XGSFormSelect from "ui-components/form/select/xgsFormSelect";
import { LabelModes } from "ui-components/molecules/labeled-inputs/labeledInput";
import Button, { ButtonSizes, ButtonThemes } from "ui-components/button/button";
import { XGSSelectOption } from "ui-components/xgs-select/xgsSelect";
import { PickupStatus } from "app/data/common/route";
import { PickupAssignRequestModel } from "app/data/pickup/models";
import { useAssignDrivers } from "../hooks/useAssignDrivers";

export interface DriverOption {
  label: string;
  value: string;
}

interface DriverFilter {
  driver?: XGSSelectOption;
}

interface AssignDriverBarProps {
  selectedCount: number;
  drivers: XGSSelectOption[];
  selectedPickupIds: string[];
}

const AssignDriverBar: React.FC<AssignDriverBarProps> = ({
  selectedCount,
  selectedPickupIds,
  drivers
}) => {

  const [driver, setDriver] = useState<XGSSelectOption | null>(null);
  const { assignDrivers, isAssigning } = useAssignDrivers();

  return (
    <Formik
      initialValues={{}}
      onSubmit={() => {
        if (isAssigning || !selectedPickupIds.length || !driver?.value) return;
        const driverIdNum = Number(driver.value);
        if (Number.isNaN(driverIdNum)) return;

        const pickupsRequest: PickupAssignRequestModel[] = selectedPickupIds.map((pickupId) => ({
          pickupId,
          driverId: driverIdNum,
          status: PickupStatus.ASSIGNED,
        }));

        assignDrivers(pickupsRequest);
      }}
    >
      {(props: FormikProps<DriverFilter>) => (
        <Form className="assign-driver-bar">
          <div className="assign-driver-bar__selected">
            {selectedCount} Selected
          </div>
          <div className="assign-driver-bar__form">
            <XGSFormSelect
              label=""
              name="driver"
              placeholder="Select driver"
              onValueChange={(_driver: XGSSelectOption | null | undefined) => {
                setDriver(_driver ?? null);
              }}
              value={driver}
              options={drivers}
              className="xgs-item-form__field"
              labelMode={LabelModes.column}
              disabled={isAssigning}
            />
          </div>

          <div className="assign-driver-bar__action">
            <Button
              type="submit"
              size={ButtonSizes.small}
              theme={ButtonThemes.blue}
              spinner={isAssigning}
            >
              {isAssigning ? "Assigning…" : "Assign"}
            </Button>
          </div>

        </Form>


      )}
    </Formik>
  );
};

export default AssignDriverBar;